/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UpdateAuthorityDto
 */
export interface UpdateAuthorityDto {

    /**
     * @type {string}
     * @memberof UpdateAuthorityDto
     */
    name?: string;

    /**
     * @type {string}
     * @memberof UpdateAuthorityDto
     */
    description?: string;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateAuthorityDto
     */
    client?: JoinEntityDto;

    /**
     * @type {Array<JoinEntityDto>}
     * @memberof UpdateAuthorityDto
     */
    permissions?: Array<JoinEntityDto>;
}
